// extracted by mini-css-extract-plugin
export default {"imageWrapper":"Pk6w8","image":"c9h0M"};